export const testimonials = [
  {
    id: 1,
    quote: 'Book My Studio Space made it incredibly easy to find and book a professional photography studio for our product launch campaign. The space was immaculate and the equipment was top-tier. We\'ll never use another booking platform.',
    name: 'Sarah Mitchell',
    role: 'Creative Director, Apex Branding Co.',
    rating: 5,
    initials: 'SM',
    color: 'bg-rose-500',
  },
  {
    id: 2,
    quote: 'We used Book My Studio Space for our entire podcast season — twelve episodes, zero issues. The booking process was seamless, the recording booths were perfectly soundproofed, and the results were broadcast quality.',
    name: 'James Torres',
    role: 'Host, The Daily Grind Podcast',
    rating: 5,
    initials: 'JT',
    color: 'bg-amber-500',
  },
  {
    id: 3,
    quote: 'As a fashion photographer, I\'ve rented dozens of studios worldwide. Book My Studio Space consistently delivers the highest quality environments with equipment that actually works. Absolutely my go-to platform.',
    name: 'Priya Nair',
    role: 'Fashion & Portrait Photographer',
    rating: 5,
    initials: 'PN',
    color: 'bg-teal-500',
  },
  {
    id: 4,
    quote: 'Our production agency uses Book My Studio Space for every client project. The flexibility to book by the hour means we never overpay. The studios are always pristine and the team is incredibly responsive.',
    name: 'Marcus Webb',
    role: 'Executive Producer, Lumen Films',
    rating: 5,
    initials: 'MW',
    color: 'bg-stone-700',
  },
  {
    id: 5,
    quote: 'I\'ve grown my YouTube channel from 10k to 500k subscribers partly thanks to the content creation studios here. Professional environment, professional results every single time. Worth every penny.',
    name: 'Emma Clarke',
    role: 'Content Creator & Influencer',
    rating: 5,
    initials: 'EC',
    color: 'bg-orange-500',
  },
];
